import type { SvgLogosOthersList } from '@snowit/assets';
import type { TypoSize } from '@snowit/icetypes';

import { CDN_URL } from './cdnUrl';
import { Tenants } from './tenants';

export { CDN_URL, Tenants };

export type CustomFont = 'TT Firs Neue';

/** list of tenant with their theme */
export const TENANTS_THEME_OVERRIDE = {
  [Tenants.DISCOVERA]: 'discovera',
  [Tenants.BENEFICY_DISCOVERA]: 'discovera',
  [Tenants.JOINTLY_DISCOVERA]: 'discovera',
  [Tenants.GETYOURGUIDE]: 'discovera',
  [Tenants.GAZZETTA_BIKEIT]: 'gazzetta',
  [Tenants.GAZZETTA_TRIBALA]: 'gazzetta',
  [Tenants.GITE_IN_TRENO]: 'gite',
  [Tenants.LOMBARDIA]: 'lombardia',
};

export const TENANTS_FONT_OVERRIDE: { [x in Tenants]?: CustomFont } = {
  [Tenants.CERVINO_SKI]: 'TT Firs Neue',
};

type TenantCollab = Record<string, { logo: SvgLogosOthersList; to?: string }>;

export const TENANTS_COLLABORATION: TenantCollab = {
  [Tenants.GAZZETTA_TRIBALA]: {
    logo: 'logo_gazzetta',
    to: 'https://www.gazzetta.it/',
  },
  [Tenants.GAZZETTA_BIKEIT]: {
    logo: 'logo_gazzetta',
    to: 'https://www.gazzetta.it/',
  },
};

export const FOREIGN_TENANTS = [Tenants.SNOWIT_EN, Tenants.SNOWIT_EUROPE];
export const NON_TENANTS = [Tenants.BOLONICE];
export const NO_INSURANCE_TENANTS = [Tenants.SVAGO_TRIBALA];
export const PARENT_TENANTS = [Tenants.SNOWIT, Tenants.BIKEIT, Tenants.TRIBALA, Tenants.DISCOVERA];

export enum Unicodes {
  ARROW_RIGHT = ' \u{02192} ',
  BULLET = ' \u{02022} ',
  COLON = '\u{0003A} ',
  COMMA = '\u{0002C} ',
  ELLIPSIS = '\u{02026} ',
  HYPHEN = ' \u{02010} ',
  HYPHEN_NO_SPACE = '\u{02010}',
  MULTIPLICATION = ' \u{000D7} ',
  PERCENT = '\u{00025}',
  PIPE = ' \u{0007C} ',
  PLUS = ' \u{0002B} ',
  SLASH = ' \u{0002F} ',
  EURO = '\u{020AC}',
}

export enum Units {
  M = 'm',
  KM = 'km',
  MSLM = 'm s.l.m',
  PERCENT = '\u{00025}',
}

export const DEVELOPMENT =
  process.env.SNOWIT_COMMAND === 'start' || process.env.SNOWIT_ENVIRONMENT === 'development';

export const ALL_ID = '_all';

export const NO_OP = () => {};

export enum Keyboard {
  UP = 'ArrowUp',
  DOWN = 'ArrowDown',
  LEFT = 'ArrowLeft',
  RIGHT = 'ArrowRight',
  ESC = 'Escape',
  ENTER = 'Enter',
  TAB = 'Tab',
}

export enum PPURankingColorEnum {
  GOLD = '#d4af37',
  SILVER = '#c0c0c0',
  BRONZE = '#b08d57',
}

export const BANNER_ID_SEPARATOR = '__';
export const BANNER_PREFIX = `banner${BANNER_ID_SEPARATOR}`;

export const COLOR_CONTRAST_THRESHOLD = 3;

export const TYPO_SIZE_SCALE: Record<TypoSize, number> = {
  qt: 5,
  qr: 4,
  tr: 3,
  big: 2.5,
  db: 2,
  xxl: 1.5,
  xl: 1.25,
  lg: 1.125,
  df: 1,
  md: 0.875,
  sm: 0.75,
  xs: 0.625,
  xxs: 0.5,
  /** @deprecated use tr instead */
  xbig: 2.5,
};
